// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-30d8b17e]{padding-top:0}.wrapper[data-v-30d8b17e]{margin-top:-64px;display:flex;min-height:calc(100vh - 64px);flex-direction:column}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
